declare global {
  interface Window {
    grecaptcha?: {
      ready: (callback: () => void) => void;
      execute: (siteKey: string, options: { action: string }) => Promise<string>;
    };
  }
}

let loadPromise: Promise<boolean> | null = null;

export const isBrowserAutomated = (): boolean => {
  if (typeof window === 'undefined') return false;
  if (navigator.webdriver) return true;
  const win = window as any;
  if (win.Cypress || win.puppeteer || win.__nightwatch || win._phantom || win.callPhantom) {
    return true;
  }
  if (navigator.userAgent.includes("HeadlessChrome")) return true;
  return false;
};

export const executeRecaptchaV3 = (siteKey: string, action: string = 'admin_login', enabled: boolean = true): Promise<string | null> => {
  return new Promise((resolve) => {
    if (!enabled || typeof window === 'undefined' || !siteKey || siteKey === 'YOUR_RECAPTCHA_SITE_KEY') {
      resolve(null);
      return;
    }

    if (isBrowserAutomated()) {
      resolve("AUTOMATION_DETECTED");
      return;
    }

    const scriptId = 'google-recaptcha-v3-script';

    const runExecution = () => {
      if (window.grecaptcha) {
        window.grecaptcha.ready(() => {
          window.grecaptcha!
            .execute(siteKey, { action })
            .then((token: string) => resolve(token))
            .catch((err) => {
              console.warn('reCAPTCHA v3 execution failed:', err);
              resolve(null);
            });
        });
      } else {
        resolve(null);
      }
    };

    if (window.grecaptcha) {
      runExecution();
      return;
    }

    if (!loadPromise) {
      loadPromise = new Promise((resolveLoad) => {
        const existingScript = document.getElementById(scriptId) as HTMLScriptElement | null;
        if (existingScript) {
          existingScript.addEventListener('load', () => resolveLoad(true));
          existingScript.addEventListener('error', () => resolveLoad(false));
          return;
        }

        const script = document.createElement('script');
        script.id = scriptId;
        script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
        script.async = true;
        script.onload = () => resolveLoad(true);
        script.onerror = () => resolveLoad(false);
        document.head.appendChild(script);
      });
    }

    loadPromise.then((success) => {
      if (success) {
        runExecution();
      } else {
        resolve(null);
      }
    });
  });
};
